import { FC, ReactNode } from 'react';
import { Container } from '@mui/material';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

const PageTitle = styled(Box)(
  ({ theme }) => `
        padding: ${theme.spacing(4, 0)};
`
);

interface PageTitleWrapperProps {
  children?: ReactNode;
  paddingLeft?: boolean;
}

const PageTitleWrapper: FC<PageTitleWrapperProps> = ({
  children,
  paddingLeft
}) => {
  return (
    <>
      <PageTitle>
        <Container
          style={{ paddingLeft: `${paddingLeft && '0'}` }}
          maxWidth="xl"
        >
          {children}
        </Container>
      </PageTitle>
    </>
  );
};

PageTitleWrapper.propTypes = {
  children: PropTypes.node.isRequired
};

export default PageTitleWrapper;
